import { Box } from '@ltvco/refresh-lib/theme';
import { useContext } from 'react';
import { useNavigate } from 'react-router-dom';

import { StyledConversationList } from 'components/ChatBV/components/Sidebar/ChatHistory/components';
import { ConversationItem } from 'components/ChatBV/components/Sidebar/ChatHistory/ConversationItem';
import { DeepSearchContext } from 'components/DeepSearch/context';

export const DeepSearchConversationList = ({
  collapsed,
  onConversationClick,
}: {
  collapsed: boolean;
  onConversationClick?: () => void;
}) => {
  const { conversations, activeConversationId, selectConversation } =
    useContext(DeepSearchContext);
  const navigate = useNavigate();

  const handleConversationClick = (id: string) => {
    selectConversation(id);
    navigate(`/deepsearch/chat/conversation/${id}`);
    onConversationClick?.();
  };

  return (
    <StyledConversationList collapsed={collapsed}>
      <Box>
        {conversations.map((conversation) => {
          const isActive = conversation.id === activeConversationId;
          const firstData = conversation.messages[0]?.data;
          const firstMessage = typeof firstData === 'string' ? firstData : null;
          const title = firstMessage
            ? firstMessage.slice(0, 60)
            : 'New conversation';
          return (
            <ConversationItem
              key={conversation.id}
              title={title}
              isActive={isActive}
              onClick={() => handleConversationClick(conversation.id)}
            />
          );
        })}
      </Box>
    </StyledConversationList>
  );
};
